var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppBody',{attrs:{"title":"Configurações","subtitle":"Config. de Ambientes"}},[_c('Tabs',{attrs:{"tabs":_vm.tabs}},[_c('VTabItem',[_c('General')],1),_c('VTabItem',[_c('Store')],1),_c('VTabItem',[_c('MarketplaceSettings')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }